export const TTSContextType = {
  SUCCESS: "success",
  ERROR: "error",
  SUCCESS_EMPTY: "success_empty",
  ERROR_EMPTY: "error_empty",
};
